import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getThemeTokens } from '../tokens';

export const styledMuiListItemText = (
  theme: Theme,
): BackstageOverrides['MuiListItemText'] => ({
  root: {
    marginLeft: theme.spacing(1),
  },
  primary: {
    color: getThemeTokens(theme).textPrimary,
    fontWeight: 600,
  },
  secondary: {
    color: getThemeTokens(theme).textMuted,
  },
});
